// extracted by mini-css-extract-plugin
export default {"container":"SectionHeader_container__lApFP","title":"SectionHeader_title__+N9Pz"};